import React from 'react';

interface SyringeProps {
  calculatedVolume: number;
}

const Syringe: React.FC<SyringeProps> = ({ calculatedVolume }) => {
  const syringes: number[] = [];
  const totalUnits = Math.round(calculatedVolume * 100);
  const fullSyringes = Math.floor(totalUnits / 100);
  const remainingUnits = totalUnits % 100;

  for (let i = 0; i < fullSyringes; i++) {
    syringes.push(100);
  }
  if (remainingUnits > 0) {
    syringes.push(remainingUnits);
  }

  return (
    <div style={{ width: '85%', margin: '0 auto' }}>
      {syringes.map((units, index) => (
        <svg
          key={index}
          width="100%"
          height="100%"
          viewBox="0 0 320 75"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label={`Syringe displaying ${units} units`}
        >
          {/* Syringe needle */}
          <line x1={0} y1={37.5} x2={40} y2={37.5} stroke="#b0b0b0" strokeWidth={4} />
          {/* Syringe body */}
          <rect x={40} y={25} width={250} height={25} fill="#e0e0e0" stroke="#b0b0b0" strokeWidth={2} />
          {/* Units marking with numbers */}
          {Array.from({ length: 11 }, (_, i) => (
            <g key={i}>
              <line x1={40 + i * 23} y1={25} x2={40 + i * 23} y2={50} stroke="#333" strokeWidth={1} />
              <text x={40 + i * 23 - 5} y={20} fontSize={10} fill="#333">
                {i * 10}
              </text>
            </g>
          ))}
          {/* Fill level */}
          <rect x={40} y={25} width={Math.min(units * 2.3, 250)} height={25} fill="#4CAF50" />
          {/* Black stopper */}
          <line
            x1={Math.min(40 + units * 2.3, 290)}
            y1={25}
            x2={Math.min(40 + units * 2.3, 290)}
            y2={50}
            stroke="#000"
            strokeWidth={4}
          />
          {/* Syringe plunger */}
          <rect x={290} y={20} width={20} height={35} fill="#b0b0b0" stroke="#808080" strokeWidth={2} />
        </svg>
      ))}
    </div>
  );
};

export default Syringe;
